module.exports = __webpack_public_path__ + "img/9788992263009.5813a334.jpg";